import NewUserApiKey from "../../../../components/@userApiKeys/userApiKeys/NewUserApiKey";
import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UserApiKeyNewPage() {

    return NewUserApiKey({
        routeType: routeTypes.admin
    })
}       